<template>
	<div>
		<v-row>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row mb-1" flat >
					<v-card  flat >
						<img src="../../../assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card  flat >
						<p>{{$lang.TRANSACTION_ID}}</p>
						<p class="sub-title-text">{{shipment_details.transaction_id}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row mb-1 pt-0" flat >
					<v-card   flat >
						<v-btn color="primary" outlined fab  x-small  class="mt-4">
							<v-icon color="primary">mdi-currency-inr</v-icon>
						</v-btn>
					</v-card>
					<v-card class="pa-2" flat >
						<p>{{$lang.COD_AMOUNT}}</p>
						<p class="sub-title-text">{{shipment_details.amount}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row mb-1 pt-0" flat >
					<v-card   flat >
						<img src="@/assets/return-green.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card class="pa-2" flat >
						<p>{{$lang.TOTAL_RETURNS}}</p>
						<p class="sub-title-text">{{shipment_details.returned_count}}</p>
					</v-card>
				</v-card>
			</v-col>
			<v-col md="3" class="pt-0">
				<v-card class="d-flex flex-row mb-1 pt-0" flat >
					<v-card   flat >
						<img src="@/assets/transaction_type.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card class="pa-2" flat >
						<p>{{$lang.TRANSACTION_TYPE}}</p>
						<p class="sub-title-text">{{shipment_details.type}}</p>
					</v-card>
				</v-card>
			</v-col>
		</v-row>
		<v-row>
			<v-col md="4" class="pt-0">
				<v-card class="d-flex flex-row mb-1" flat >
					<v-card  flat >
						<img src="../../../assets/order.svg" alt="img"  width="25px" class="mt-3 mr-1">
					</v-card>
					<v-card  flat >
						<p>{{$lang.EXECUTED_ON}}</p>
						<p class="sub-title-text" v-if="shipment_details.received_on">{{shipment_details.received_on}}</p>
						<p class="sub-title-text pl-4" v-else>-</p>
					</v-card>
				</v-card>
			</v-col>

			<v-col md="3" class="pt-0">
				<p class="sub-title-text-dark">{{$lang.RECEIVED_BY}}</p>
				<p class="sub-title-text-dark secondary-text fs-13" v-if="shipment_details.recipient_name">{{shipment_details.recipient_name}}</p>
				<p class="sub-title-text pl-4" v-else>-</p>

			</v-col>
			<v-col md="4" class="pt-0" v-if="$store.state.user_type==$keys.WHOLESALER">
				<p class="sub-title-text-dark">{{$lang.OTP.toUpperCase()}}</p>
				<p class="sub-title-text-dark secondary-text fs-13">{{shipment_details.transaction_otp}}</p>
			</v-col>
		</v-row>
	</div>
</template>
<script type="text/javascript">
export default {
	props:['shipment_details'],
}
</script>